import { Injectable } from '@angular/core';
import { BdcWalkService } from 'bdc-walkthrough';
import { debounceTime, takeUntil } from 'rxjs';
import { ComponentStore } from '@ngrx/component-store';

export type OnboardingState = {
  isOnboardingEnabled: boolean;
  isOnboardingBeingShowed: boolean;

  isNeedToShowLayersAddPopup: boolean;
  isNeedToShowNewBoardPopup: boolean;
  isNeedToShowGuestClickElementPopup: boolean;

  state: {
    layers: boolean;
    library: boolean;
    drawings: boolean;
    menu: boolean;
    layersAdd: boolean;
    newMapPopup: boolean;
  };
};
@Injectable({
  providedIn: 'root',
})
export class OnboardingService extends ComponentStore<OnboardingState> {

  constructor(private bdcService: BdcWalkService) {
    super({
      isOnboardingEnabled: false,
      isOnboardingBeingShowed: false,

      isNeedToShowLayersAddPopup: false,
      isNeedToShowNewBoardPopup: false,
      isNeedToShowGuestClickElementPopup: false,

      state: {
        layers: false,
        library: false,
        drawings: false,
        menu: false,
        layersAdd: false,
        newMapPopup: false,
      },
    });

    this.bdcService.changesDisplaying
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe((it) => {
        if (!it.id) {
          return;
        }
        const state = this.get();
        this.patchState({
          isOnboardingBeingShowed: it.visible,
        });

        // @ts-ignore
        const finishedTasks = this.bdcService.getTasks();

        const possibleTasks = ['layers', 'library', 'drawings', 'menu', 'layersAdd', 'newMapPopup'];
        Object.keys(finishedTasks).forEach((it) => {
          if (possibleTasks.indexOf(it) !== -1) {
            this.patchState({
              state: {
                ...state.state,
                [it]: finishedTasks[it],
              },
            });
          }
        });
      });
  }

  private getState() {
    return this.bdcService.getTasks();
  }

  public onUserLoggedIn() {
    this.patchState({
      isOnboardingEnabled: true,
    });
  }

  public setElementClickSuggestEnabled(isEnabled: boolean) {
    this.patchState({
      isNeedToShowGuestClickElementPopup: isEnabled,
    });

    this.bdcService.setTaskCompleted('clickGuestElement', false)
  }
}
